// Module
var code = "<template id=\"block-10__image-template\"> <div class=\"block-10__image image\"></div> </template> ";
// Exports
export default code;